import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { FlexBoxModule } from "@lantern/app/common/flex-box";
import { ButtonGroupModule } from "@lantern/app/common/forms/button-group/button-group.module";
import { ButtonComponentModule } from "@lantern/app/common/forms/button/button-component.module";
import { FormFieldComponentModule } from "@lantern/app/common/forms/form-field/form-field-component.module";
import { InputComponentModule } from "@lantern/app/common/forms/input/input-component.module";
import { SelectModule } from "@lantern/app/common/forms/select";
import { TextareaComponentModule } from "@lantern/app/common/forms/textarea/textarea-component.module";
import { IconModule, TooltipModule } from "@lantern/app/common/utils";

import { CollapseAllService } from "./collapse-all.service";
import { JsonArrayEditorComponent } from "./json-array-editor.component";
import { JsonEditorComponent } from "./json-editor.component";
import { JsonNewChildFormComponent } from "./json-new-child-form.component";
import { JsonObjectEditorComponent } from "./json-object-editor.component";
import { JsonRootNodeComponent } from "./json-root-node.component";
import { JsonTextEditorComponent } from "./json-text-editor.component";
import { JsonValueEditorComponent } from "./json-value-editor.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FormFieldComponentModule,
    ReactiveFormsModule,
    ButtonComponentModule,
    IconModule,
    InputComponentModule,
    SelectModule,
    TooltipModule,
    TextareaComponentModule,
    ButtonGroupModule,
    BrowserAnimationsModule,
    FlexBoxModule
  ],
  declarations: [
    JsonObjectEditorComponent,
    JsonArrayEditorComponent,
    JsonNewChildFormComponent,
    JsonRootNodeComponent,
    JsonValueEditorComponent,
    JsonEditorComponent,
    JsonTextEditorComponent
  ],
  providers: [CollapseAllService],
  exports: [JsonEditorComponent, JsonTextEditorComponent]
})
export class JsonEditorComponentModule {}
